"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _MenuBar = _interopRequireDefault(require("../../../common/MenuBar/MenuBar"));

var _WfsSearchByPropertyMenuBar = _interopRequireDefault(require("../WfsSearchByPropertyMenuBar/WfsSearchByPropertyMenuBar"));

var _WfsSearchByPointMenuBar = _interopRequireDefault(require("../WfsSearchByPointMenuBar/WfsSearchByPointMenuBar"));

var _WfsSearchByBBoxMenuBar = _interopRequireDefault(require("../WfsSearchByBBoxMenuBar/WfsSearchByBBoxMenuBar"));

var _WfsSearchByPolygonMenuBar = _interopRequireDefault(require("../WfsSearchByPolygonMenuBar/WfsSearchByPolygonMenuBar"));

var _WfsSearchByCQLFilterMenuBar = _interopRequireDefault(require("../WfsSearchByCQLFilterMenuBar/WfsSearchByCQLFilterMenuBar"));

var _useWindowSize2 = _interopRequireDefault(require("../../../../../hooks/ui/useWindowSize"));

var _deviceUnits = require("../../../../../core/deviceUnits");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var WfsSearchMenuBar = function WfsSearchMenuBar(_ref) {
  var map = _ref.map,
      layer = _ref.layer,
      url = _ref.url,
      wfsOptions = _ref.wfsOptions,
      columnDefs = _ref.columnDefs,
      _ref$breakpoint = _ref.breakpoint,
      breakpoint = _ref$breakpoint === void 0 ? (0, _deviceUnits.convertRemToPixels)(75) : _ref$breakpoint,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Search" : _ref$title;

  var _useState = (0, _react.useState)(1),
      _useState2 = _slicedToArray(_useState, 2),
      searchType = _useState2[0],
      setSearchType = _useState2[1];

  var _useWindowSize = (0, _useWindowSize2.default)(),
      width = _useWindowSize.width; //const direction = width > breakpoint  ?


  var onChangeSearchType = function onChangeSearchType(e) {
    setSearchType(e.target.value);
  };

  var radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '50px'
  };
  var childSearchPanel = null;

  switch (searchType) {
    case 1:
      childSearchPanel = /*#__PURE__*/(0, _jsxRuntime.jsx)(_WfsSearchByPropertyMenuBar.default, {
        url: url,
        map: map,
        layer: layer,
        direction: width > breakpoint ? "horizontal" : "vertical",
        wfsOptions: wfsOptions,
        columnDefs: columnDefs
      });
      break;

    case 2:
      childSearchPanel = /*#__PURE__*/(0, _jsxRuntime.jsx)(_WfsSearchByPointMenuBar.default, {
        url: url,
        map: map,
        layer: layer,
        wfsOptions: wfsOptions
      });
      break;

    case 3:
      childSearchPanel = /*#__PURE__*/(0, _jsxRuntime.jsx)(_WfsSearchByBBoxMenuBar.default, {
        url: url,
        map: map,
        layer: layer,
        wfsOptions: wfsOptions
      });
      break;

    case 4:
      childSearchPanel = /*#__PURE__*/(0, _jsxRuntime.jsx)(_WfsSearchByPolygonMenuBar.default, {
        url: url,
        map: map,
        layer: layer,
        wfsOptions: wfsOptions
      });
      break;

    case 5:
      childSearchPanel = /*#__PURE__*/(0, _jsxRuntime.jsx)(_WfsSearchByCQLFilterMenuBar.default, {
        url: url,
        map: map,
        layer: layer,
        wfsOptions: wfsOptions
      });
      break;

    case 6:
      childSearchPanel = null;
      break;

    default:
      childSearchPanel = null;
  }

  var searchMenu = /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Radio.Group, {
        onChange: onChangeSearchType,
        value: searchType,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Radio, {
          style: radioStyle,
          value: 1,
          children: "By Property"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Radio, {
          style: radioStyle,
          value: 2,
          children: "By Point"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Radio, {
          style: radioStyle,
          value: 3,
          children: "By BBox"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Radio, {
          style: radioStyle,
          value: 4,
          children: "By Polygon"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Radio, {
          style: radioStyle,
          value: 5,
          disabled: true,
          children: "By CQL"
        })]
      })
    }, "1")
  });
  return (
    /*#__PURE__*/
    // <Space>
    (0, _jsxRuntime.jsxs)(_MenuBar.default, {
      breakpoint: breakpoint,
      title: title,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Dropdown, {
        overlay: searchMenu,
        placement: "bottomLeft",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, {
          children: "Search Type"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Divider, {
        type: "vertical"
      }), childSearchPanel]
    }) // </Space>

  );
};

var _default = WfsSearchMenuBar;
exports.default = _default;